import React, { Component } from 'react';
import Table from "../../../../components/UI/Table/Table";
import moment from 'moment';
import { Link } from "react-router-dom";
import { DATE_FORMAT } from '../../../../constants';


const tableColumns = [
    {
        Header: "Risk Factor Name",
        id: 'riskFactorName',
        accessor: 'riskFactorName',
        Cell: row => (
            <Link to={'/riskfactor/view/' + row.original.id}>{row.value}</Link>
        )

    },
    {
        Header: "Risk Factor Type",
        id: 'riskFactorType',
        accessor: 'riskFactorType'
    },
    {
        Header: 'Created On',
        id: 'createdAt',
        accessor: p => <p title={moment(p.createdAt).format(DATE_FORMAT)}>{moment(p.createdAt).format(DATE_FORMAT)}</p>,
        sortMethod: (a, b) => {
            a = new Date(a.props.title).getTime();
            b = new Date(b.props.title).getTime();
            return b > a ? 1 : -1;
        }
    },
    {
        Header: 'Risk Factor DataType',
        id: 'riskFactorDataType',
        accessor: 'riskFactorDataType'
    },
    {
        Header: 'Category',
        id: 'category',
        accessor: 'category'
    }
]

class ViewALLRiskTableView extends Component {
    render() {
        return (
            <Table
                data={this.props.data}
                columns={tableColumns}
                defaultPageSize={10}
                className="CreateCaseModalTable highlight"
                loading={this.props.loading}
                noDataText="No RiskFactor found"
            />
        )
    }
}

export default ViewALLRiskTableView;
